
import ScanFlagIllustration from "@/app/ui/components/scan-flags/index.vue";
import { getScanFlags, hasScanFlags } from "@/domain/entities/ScanFlags";
/* eslint-disable @typescript-eslint/camelcase */
import { mixins, Options } from "vue-class-component";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import OverlayPanel from "primevue/overlaypanel";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import InputDimension from "@/app/ui/components/input-dimension/index.vue";
import InputAdornment from "@/app/ui/components/input-adornment/index.vue";
import NotificationCommodityGrouping from "@/app/ui/components/notification-commodity-group/index.vue";
import debounce from "lodash/debounce";
import { BaggingController } from "@/app/ui/controllers/BaggingController";
import {
  BaggingData,
  PayloadCreateBagging,
  RegionBaggingGrouping,
  SttNumberDetail,
  BaggingScanFailed,
} from "@/domain/entities/Bagging";
import {
  storeDatatoLocalStorage,
  removeDataLocalStorage,
} from "@/app/infrastructures/misc/Utils";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import convertDecimal from "@/app/infrastructures/misc/common-library/ConvertDecimal";
import formatByCountry, { resolveCountry } from "@/app/infrastructures/misc/common-library/FormatByCountry";
import formatInputByCountry, { parseByCountry } from "@/app/infrastructures/misc/common-library/FormatInputByCountry";
import isMigrateFromElexys from "@/app/infrastructures/misc/common-library/IsMigrateFromElexys";
import Print from "../../modules/print.vue";
import OutGoingMixins from "@/app/ui/views/out-going-shipment/out-going-mixin";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { getScanNotificationSound, playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import Checkbox from "primevue/checkbox";
import { flags } from "@/feature-flags";
import { TrackingController } from "@/app/ui/controllers/TrackingController";
import {
  TrackingSttData,
  TrackingSttDetailData,
} from "@/domain/entities/TrackingStt";
import isFormatLiloBag from "@/app/infrastructures/misc/common-library/isFormatLiloBag";
import { formatInputNoDecimal } from "@/app/infrastructures/misc/common-library/FormatInputNoDecimal";
import ScanFailedCard from "../../component/scan-failed-card/index.vue";
import SectionUploadPhotoForWeightAdjusment from "../section-upload-photo-for-weight-adjustment/index.vue";
import { UploadMultiple } from "@/domain/entities/MainApp";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { UploadHydraFileRequest, DeleteHydraFileRequest } from "@/data/payload/api/BookingRequest";
import { FlagsPermissionBagging } from "@/feature-flags/flags-permission-bagging";

@Options({
  components: {
    ScanFlagIllustration,
    DetailLayout,
    OverlayPanel,
    InputDimension,
    InputAdornment,
    Print,
    NotificationCommodityGrouping,
    Checkbox,
    ScanFailedCard,
    SectionUploadPhotoForWeightAdjusment
  },
   watch: {
    'form.weight'(newVal: string) {
     const weight = parseByCountry(String(newVal));
      const length = Number(this.form.length);
      const width = Number(this.form.width);

      if (!this.isValidationAdjustWeightProofPhotoEnable && this.isValidationPhotoProofHasPermission) {
        this.form.photoProof = [];
      }

      if (isNaN(weight) || isNaN(length) || isNaN(width) || length === 0 || width === 0 || weight === 0) {
        this.form.height = 0;
        return;
      }

      const result =
        (Number(this.isValueDecimal(Number(this.weightRoundUpCustom))) * this.dimensionDivider) /
        (length * width);
      const decimalPart = result - Math.floor(result);

      let finalHeight;
      if (decimalPart > 0) {
        finalHeight = Math.floor(result);
        if (finalHeight === 0) finalHeight = 1;
      } else {
        finalHeight = result;
      }

      this.form.height = finalHeight;
    },
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess && !this.isPartial) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      this.setOpenSuccess(false);
      this.isPartial = false;
      next();
    }
  },
  directives: {
    "click-outside": {
      beforeMount: function(el, binding) {
        const ourClickEventHandler = (event: any) => {
          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event);
          }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;
        document.addEventListener("click", ourClickEventHandler);
      },
      unmounted: function(el) {
        document.removeEventListener("click", el.__vueClickEventHandler__);
      },
    },
  },
})
class CreateFormBaggingManifest extends mixins(OutGoingMixins) {
  alertDangerousGoods = false;
  isErrorBagging = false;
  notificationTimeout?: NodeJS.Timeout = undefined;
  isGrossWeightDiff = false;
  openAdjustmentWeight = true;
  isDimensionChange = true;
  isFirstLanding = true;

   detailData = {
    totalBagVolumeWeight: 0,
  };

  get isValidationAdjustWeightProofPhotoEnable() {
    return this.bagWeightOverSttWeight;
  }

  get isShowRTC() {
    return flags.feature_rtc_bagging_enabled.isEnabled();
  }

  get weightRoundUpCustom() {
    const weight = this.parseWeightInput(this.form.weight);

      let rounded;
      if (weight < 1) {
        rounded = 1; // anything below 1 becomes 1
      } else {
        rounded = Math.round(weight); // otherwise normal rounding
      }

      return rounded.toString().replace(".", ",");
   }


  get bagChargeableWeight(): number {
    if (this.isFirstLanding) {
      return Number(this.form.weight);
    }
    const weight = this.parseWeightInput(this.form.weight);
    return weight > Number(this.totalBagVolumeWeight)
      ? weight
      : Number(this.totalBagVolumeWeight);
  }

  get sttChargeableWeight(): number {
    return this.totalGrossWeight > this.totalVolumeWeight
      ? this.totalGrossWeight
      : this.totalVolumeWeight;
  }

  get labelToggleRTC() {
    return {
      text: this.form.isRTC ? this.$t("bagging.siapDikargo") : this.$t("bagging.belumSiapDikargo"),
      style: this.form.isRTC
        ? "bg-green-lp-300 border border-green-lp-600"
        : "bg-gray-lp-1000",
    };
  }

  get maxWeightDispute() {
    return FlagsPermissionBagging.config_max_weight_dispute_bagging.getValue()
  }

  get bagWeightOverSttWeight() {
    const chargeableWeightStt = this.sttChargeableWeight;
    const chargeableWeightBag = this.bagChargeableWeight;

    if (chargeableWeightBag >= (chargeableWeightStt + 1)) {
      return true;
    }

    this.form.photoProof = [];
    return false;
  }

  get isAnySttMaxDisputeWhitelisted() {
    const whitelistData = FlagsPermissionBagging.config_whitelist_client_max_weight_dispute.getValue() as number[]
    return this.hasClientId(whitelistData)
  }

  get isMaxWeightDispute() {
    const chargeableWeightStt = this.sttChargeableWeight;
    const chargeableWeightBag = this.bagChargeableWeight;

    if (this.isAnySttMaxDisputeWhitelisted) return false
    if (!this.maxWeightDispute) return false
    return chargeableWeightBag > Number(Number(chargeableWeightStt + this.maxWeightDispute || 0).toFixed(2))
  }

  get isValidationPhotoProofHasPermission() {
    return FlagsPermissionBagging.validation_adjust_weight_proof_photo_enable.isEnabled();
  }

  pagination = {
    page: 1,
    limit: 50,
  };
  mounted() {
    this.fetchDestinationCity("");
    AccountController.checkAccountLocation();
    BaggingController.setResetCreateBagging();
    this.refs = this.$refs;
    if (this.dataSttToBeCreate.length)
      this.autoFillDestination(this.dataSttToBeCreate[0]);
    BaggingController.setScanFailedListKey("bagging-scan-failed");
    this.form.photoProof = []
  }
  refs: any = "";

  // delete stt pieces
  showDeleteSttNumber = false;
  sttNumberToDelete = "";
  sttNumberSuccessDelete = "";
  errorSttNumberDelete = "";
  sttNumberListTrash: string[] = [];
  onDeleteSttNumber() {
    if (this.sttNumberToDelete) {
      this.sttNumberToDelete = this.sttNumberToDelete.split("#")[0];
      this.errorSttNumberDelete = "";
      this.sttNumberSuccessDelete = "";
      this.sttNumberToDelete = this.sttNumberToDelete.toUpperCase();

      // find index no. stt
      const indexSttNumber = this.dataSttToBeCreate.findIndex((data: any) => {
        return (
          data.sttNo === this.sttNumberToDelete ||
          data.sttNumberElexys === this.sttNumberToDelete
        );
      });

      // no. stt not found
      if (indexSttNumber < 0) {
        this.errorSttNumberDelete = this.$t(
          "No. STT tidak ditemukan/sudah terhapus"
        );
      } else {
        if (this.dataSttToBeCreate.length === 1) {
          this.form.destinationCity = "";
        }
        this.dataSttToBeCreate.splice(indexSttNumber, 1);
        this.sttNumberListTrash.push(this.sttNumberToDelete);
        this.sttNumberSuccessDelete = this.sttNumberToDelete;
        // const totalGrossWeight = (Math.ceil(this.totalGrossWeight * 100) / 100)
        //   .toFixed(2)
        //   .replace(".", ",");
        // this.form.weight = totalGrossWeight;
        // store bagging gross weight to local storage
        // storeDatatoLocalStorage("baggingGrossWeight", totalGrossWeight);
        this.sttNumberToDelete = "";
        dataLayer(
          "bagging_delete_STT",
          {
            success_message: "STT berhasil dihapus",
          },
          []
        );
      }
    }
    this.isUnpaid = false;
    const deleteStt: any = this.$refs.deleteStt;
    deleteStt?.focus();
  }
  onShowDelete() {
    this.errorSttNumberDelete = "";
    this.showDeleteSttNumber = true;
    this.sttNumberToDelete = "";
    this.sttNumberSuccessDelete = "";
  }
  onCloseDelete() {
    this.showDeleteSttNumber = false;
    this.sttNumberListTrash = [];
    this.isUnpaid = false;
  }

  changeWeight(val: any) {
    if (val) {
      this.isFirstLanding=false;
    }
  }

  changeDimension(val: any) {
    if (val) {
      this.isDimensionChange = false;
      this.isFirstLanding = false;
      this.isChangeWeight = false;
    }
  }

  hasClientId(clientIdList: number[]) {
    const set = new Set(clientIdList);

    for (let i = 0; i < this.dataSttToBeCreate.length; i++) {
      if (set.has(this.dataSttToBeCreate[i].sttClientId)) {
        return true;
      }
    }

    return false;
  }


  isChangeWeight = false;
  get totalBagVolumeWeight() {
    const parsedWeight = this.parseWeightInput(this.form.weight);
    const weight = Math.round(parsedWeight);
    const length = Number(this.form.length);
    const width = Number(this.form.width);
    const height = Number(this.form.height);

    if (this.isFirstLanding) return isNaN(weight) ? 0 : weight;

    // if weight exists but length, width, height are 0, return weight
    if (weight && !length && !width && !height) return weight;
    if (this.isChangeWeight) {
      const roundWeight = parsedWeight;

      let rounded;
      if (roundWeight < 1) {
        rounded = 1; // anything below 1 becomes 1
      } else {
        rounded = Math.round(roundWeight); // otherwise normal rounding
      }

      return rounded;
    }



    const total = (length * width * height) / this.dimensionDivider;
    let totalRounded;
      if (total < 1) {
        totalRounded = 1; // anything below 1 becomes 1
      } else {
        totalRounded = Math.round(total); // otherwise normal rounding
      }
    return this.isChangeWeight ? weight : totalRounded;
  }

   recalculateHeight() {
    const length = Number(this.form.length);
    const width = Number(this.form.width);

    if (length === 0 || width === 0 || Number(this.weightRoundUpCustom.toString().replace(",", ".")) === 0) {
      this.form.height = 0;
      return;
    }

 
  
    const result = (Number(this.weightRoundUpCustom.toString().replace(",", ".")) * this.dimensionDivider) / (Number(length) * Number(width));
    if (!this.isFirstLanding) {
    this.form.height = Math.floor(result);
    }
  }





  async onUploadAdjustmentWeight(params: UploadMultiple) {
    if (!params.file) return;

    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: params.file,
          folderPath: "stt/"
        })
      );
      this.form.photoProof[params.index] = fileLink.data;
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemoveAdjustmentWeight(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.form.photoProof[index]]
        })
      );
      const statusDel = res.data[this.form.photoProof[index]];

      if (statusDel) {
        this.form.photoProof[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }
  get detailDistrict() {
    return LocationController.districtDetail;
  }
  get typeUser() {
    return this.dataProfile.account_type_detail.type === "console"
      ? "Consolidator"
      : "Sub-Consolidator";
  }
  get baggingDate() {
    return new Date();
  }

  // handle stt pieces
  isDuplicateScan = false;
  errorSttNumber = "";
  isErrorTyping = false;
  isPartial = false;
  countFailed = 0;
  countSuccess = 0;
  isScan = false;

  addScanSttNumber() {
    if (!this.isDisableAddSttNumber) {
      this.isScan = true;

      this.addSttToCreate();
    }
  }

  async addSttNumber() {
    if (!this.isDisableAddSttNumber) {
      this.isScan = false;
      await this.addSttToCreate();
    }
  }

  checkIsSTTOrBag(val: string) {
    return (
      !!val.trim().match(/^\d{1,2}LP\w+$/g) ||
      !!val.trim().match(/^\w{1,3}-\w+$/g)
    );
  }

  async handleScanOthers(str: string) {
    MainAppController.showLoading();
    try {
      const resp = await TrackingController.trackStt({
        sttNo: str,
        isGetSla: false,
        isSecondCall: false,
        cache: true,
      });
      if (resp) {
        return {
          sttNo: TrackingController.trackingSttData.sttDetail.sttNo,
          noRefExternal: str,
        };
      } else {
        playNotification("error");
        this.errorSttNumber = this.$t("bagging.tableTitle.notFoundSTTBagging");
        this.isErrorTyping = true;
      }
    } finally {
      TrackingController.setTrackingSttData(
        new TrackingSttData(new TrackingSttDetailData(), [])
      );
      MainAppController.closeLoading();
    }
  }

  async handleValidationSTTOthers(): Promise<{
    sttNo: string;
    noRefExternal: string;
  }> {
    let sttNoOthers: any = { sttNo: "", noRefExternal: "" };
    const isSTT = this.checkIsSTTOrBag(this.form.sttNumber);
    if (!isSTT) {
      sttNoOthers = await this.handleScanOthers(this.form.sttNumber);
    }
    return sttNoOthers;
  }

  onReset() {
    BaggingController.resetScanFailedList(
      new BaggingScanFailed({
        storageKey: "bagging-scan-failed",
      })
    );
  }

  get scanFailedList(): BaggingScanFailed[] {
    return BaggingController.scanFailedList;
  }
  addToScanFailedList(data: BaggingScanFailed) {
    BaggingController.addScanFailedList({
      ...data,
      storageKey: "bagging-scan-failed",
    });
  }

  async addSttToCreate() {
    this.isErrorBagging = false;
    this.errorSttNumber = "";
    this.isDuplicateScan = false;
    const sttNoOthers = await this.handleValidationSTTOthers();
    await BaggingController.getDetailSttNumber({
      sttNumber: !this.checkIsSTTOrBag(this.form.sttNumber)
        ? sttNoOthers?.sttNo ?? ""
        : this.form.sttNumber,
      callback: this.addStt,
      noRef: sttNoOthers?.noRefExternal ?? "",
      storageKey: "bagging-scan-failed",
    });

    const checkError =
      !this.checkIsSTTOrBag(this.form.sttNumber) && !sttNoOthers;
    if (checkError) {
      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          failureReason: this.errorSttNumber,
          lastStatus: "",
        })
      );
    }

    this.form.sttNumber = this.form.sttNumber.split("#")[0];
  }
  addStt(responseDetailStt: any, noRefExternal: string) {
    this.notification = false;
    const checkErrorUpdate = responseDetailStt.find(
      (item: any) => item.isAllowUpdateStatus === false
    );
    const checkEligibleUpdate = responseDetailStt.map(
      (item: any) => item.isAllowUpdateStatus !== false
    );
    const checkErrorSttNeedAssessment = responseDetailStt.find(
      (item: any) =>
        item.stt.sttAssessmentStatus === "waiting" ||
        item.stt.sttAssessmentStatus === "rejected"
    );
    this.isErrorNotification = false;
    const isNotEligible = (val: any) => val === false;
    const detailSttBagging = BaggingController.detailSttno.data[0];
    if (checkErrorSttNeedAssessment) {
      this.isErrorBagging = true;
      playNotification("error");
      this.isErrorNotification = true;
      this.errorSttNumber =
        this.$t("Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.");
      this.messageErrorNotification =
        this.$t("Silahkan menunggu CS follow up untuk konfirmasi adjust ulang STT.");
      for (const detailSTT of responseDetailStt) {
        this.onFailedSttResults(detailSTT);
      }

      clearTimeout(this.notificationTimeout as NodeJS.Timeout);
      this.notificationTimeout = setTimeout(() => {
        this.notification = false;
      }, 15000);

      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          lastStatus: detailSttBagging.lastStatus,
          failureReason: this.errorSttNumber,
        })
      );
    } else if (checkEligibleUpdate.every(isNotEligible)) {
      playNotification("error");
      this.isErrorTyping = true;
      this.errorSttNumber = this.dataProfile.account_type_detail.countryCode.toLowerCase() === "my" ? checkErrorUpdate.errorMessageEn : checkErrorUpdate.errorMessage;

      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          failureReason: this.errorSttNumber,
          lastStatus: detailSttBagging.lastStatus,
        })
      );
    } else {
      for (const detailSTT of responseDetailStt) {
        this.onValidateSttResults(detailSTT, noRefExternal);
      }
      // re focus
      const inputStt: any = this.$refs.inputStt;
      inputStt.focus();

      // remove notification after 15 second
      if (!this.isUnpaid) {
        clearTimeout(this.notificationTimeout as NodeJS.Timeout);
        this.notificationTimeout = setTimeout(() => {
          this.notification = false;
          this.notificationCommodityGrouping = false;
        }, 15000);
      }
    }
  }
  onValidateSttResults(detailSTT: any, noRefExternal: string) {
    this.isDuplicateScan = false;
    this.alertDangerousGoods = false;
    this.notification = false;
    const indexCurrentSttNumber = this.dataSttToBeCreate.findIndex(
      (data: any) => {
        return data.sttNo === detailSTT.stt.sttNo;
      }
    );
    if (indexCurrentSttNumber > -1) {
      this.isDuplicateScan = true;
      playNotification("duplicate");
      this.errorSttNumber = this.$t("STT Sudah Di Scan");
      this.isErrorTyping = true;
      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          failureReason: this.errorSttNumber,
          lastStatus: detailSTT.lastStatus,
          success: true,
        })
      );
      return;
    } else if (!detailSTT.isPaid) {
      this.isUnpaid = true;
      this.isErrorNotification = true;
      this.messageErrorNotification = this.$t(
        "Tunggu sampai customers selesai melunasi tagihan kurang bayar"
      );
      this.errorSttNumber = this.$t(
        "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Bagging."
      );
      playNotification("error");
      dataLayer(
        "input_STT/bagging_failed",
        {
          error_message: this.isScan
            ? "Scan No. STT Gagal"
            : "Tambah No. STT Gagal",
        },
        []
      );
      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          failureReason: this.errorSttNumber,
          lastStatus: detailSTT.lastStatus,
        })
      );
    } else if (
      this.form.destinationCity?.code &&
      this.form.destinationCity?.code !== detailSTT.stt.sttDestinationCityId &&
      this.validationIntraRegion(detailSTT)
    ) {
      this.errorSttNumber = this.$t(
        "No. STT tidak sesuai dengan kota tujuan yang dipilih"
      );
      this.isErrorNotification = true;
      this.isDiffDestination = true;
      this.messageErrorNotification = this.$t(
        "STT tidak sesuai dengan kota tujuan yang dipilih"
      );
      playNotification("error");
      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          failureReason: this.errorSttNumber,
          lastStatus: detailSTT.lastStatus,
        })
      );
      return;
    } else {
      if (detailSTT.isAllowUpdateStatus) {
        detailSTT.stt.sttNoRefExternal = noRefExternal;
        this.dataSttToBeCreate.push({
          ...detailSTT.stt,
          regionBaggingGrouping: detailSTT.regionBaggingGrouping,
        });
        if (
          detailSTT.regionBaggingGrouping.baggingRegionOriginId &&
          detailSTT.regionBaggingGrouping.baggingRegionDestinationId
        ) {
          this.autoFillDestination(detailSTT);
        }
        playNotification(getScanNotificationSound(detailSTT.stt), this.dataProfile.accountIsForeign);
        dataLayer(
          "input_STT/bagging_success",
          {
            success_message: "STT berhasil di input",
          },
          []
        );

        this.addToScanFailedList(
          new BaggingScanFailed({
            sttNumber: this.form.sttNumber,
            success: true,
          })
        );
      }
    }
    this.onSuccessSttResults(detailSTT);
  }
  onSuccessSttResults(detailSTT: any) {
    if (!detailSTT.isPaid || !detailSTT.isAllowUpdateStatus) return;
    const flags = getScanFlags(detailSTT.stt);
    const destinationCity: any = this.form.destinationCity;
    this.detailSttNotification = {
      ...flags,
      sttNumber: detailSTT.stt.sttNo,
      destinationCity: destinationCity.name,
      product: detailSTT.stt.sttProductType,
      woodpacking: flags.isWoodpacking,
      commodity: detailSTT.stt.sttCommodityName,
      totalPieces: detailSTT.stt.sttTotalPiece,
      codAmount: detailSTT.stt.sttCodAmount,
      sttNumberElexys: detailSTT.stt.sttNumberElexys,
      isDangerousGoods: detailSTT.stt.isDangerousGoods,
      cityId: detailSTT.stt.sttDestinationCityId,
      cityName: detailSTT.stt.sttDestinationCityName,
    };
    this.form.sttNumber = "";
    this.form.cacheDestinationCity = this.form.destinationCity;
    // const totalGrossWeight = (Math.ceil(this.totalGrossWeight * 100) / 100)
    //   .toFixed(2)
    //   .replace(".", ",");
    // this.form.weight = totalGrossWeight;
    // this.form.height = Math.ceil(Number(this.isValueDecimal((Number(totalGrossWeight.replace(",", ".")) * 6000) / (this.form.length * this.form.width)).toString().replace(",", ".")));
    // storeDatatoLocalStorage("baggingGrossWeight", totalGrossWeight);

    if (hasScanFlags(flags)) {
      this.notification = false;
      this.alertDangerousGoods = true;
    } else {
      this.alertDangerousGoods = false;
      this.notification = true;
    }

    if (this.dataSttToBeCreate.length > 1 && !this.isErrorNotification) {
      if (
        this.dataSttToBeCreate[0].sttCommodityGroupCode !==
        detailSTT.stt.sttCommodityGroupCode
      ) {
        this.detailNotificationCommodityGrouping = {
          sttCommodityGroupName: this.dataSttToBeCreate[0]
            .sttCommodityGroupName,
          message: this.$t("Komoditas group tidak sama"),
        };
        this.notificationCommodityGrouping = true;
      } else {
        this.notificationCommodityGrouping = false;
      }
    }
  }

  onFailedSttResults(detailSTT: any) {
    this.detailSttNotification = {
      sttNumber: detailSTT.stt.sttNo,
      destinationCity: `${detailSTT.stt.sttDestinationCityId} - ${detailSTT.stt.sttDestinationCityName}`,
    };

    this.notification = true;
  }

  async autoFillDestination(detailSTT: any) {
    if (!this.form.destinationCity?.code) {
      await LocationController.getCityList({
        search:
          this.dataProfile.account_location.city_code ===
            detailSTT.regionBaggingGrouping.baggingRegionDestinationId ||
          detailSTT.regionBaggingGrouping.baggingRegionOriginId ===
            detailSTT.regionBaggingGrouping.baggingRegionDestinationId
            ? detailSTT.sttDestinationCityId ||
              detailSTT.stt.sttDestinationCityId
            : detailSTT.regionBaggingGrouping.baggingRegionDestinationId,
        status: "",
        page: 1,
        limit: 10,
      });
      this.form.destinationCity = this.destinationCityList[0];
      if (!this.regionBaggingGrouping.baggingRegionDestinationId) {
        this.getRegionBaggingGrouping(this.form.destinationCity?.code);
      }
    }
  }

  validationIntraRegion(detailSTT: any) {
    return detailSTT.regionBaggingGrouping.baggingRegionOriginId ===
      detailSTT.regionBaggingGrouping.baggingRegionDestinationId
      ? true
      : this.regionBaggingGrouping.baggingRegionDestinationId !==
          detailSTT.regionBaggingGrouping.baggingRegionDestinationId;
  }

  onCloseNotification() {
    this.isUnpaid = false;
    this.isDiffDestination = false;
    this.errorSttNumber = "";
    this.isDuplicateScan = false;
  }

  messageErrorNotification = "";
  get totalStt() {
    return this.dataSttToBeCreate.length;
  }
  get totalPieces() {
    return this.dataSttToBeCreate.reduce((a: any, b: any) => {
      return a + b.piece.length;
    }, 0);
  }
  get totalGrossWeight() {
    return this.dataSttToBeCreate.reduce((a: any, b: any) => {
      return (
        a +
        b.piece.reduce((c: any, d: any) => {
          return c + d.sttPieceGrossWeight;
        }, 0)
      );
    }, 0);
  }
  get totalVolumeWeight() {
    const weightVolumeStt = this.isValueDecimal(this.convertTotalKg(this.dataSttToBeCreate.reduce((sum: any, item: any) => sum + item.sttVolumeWeight, 0)));
    return Number(weightVolumeStt.toString().replace(",", "."));
  }

  get totalDangerousGoods() {
    return this.dataSttToBeCreate.filter((stt: any) => stt.isDangerousGoods)
      .length;
  }

 


  // form model
  form = {
    driverName: "",
    licensePlate: "",
    destinationCity: "" as any,
    cacheDestinationCity: "",
    pickupDate: new Date(),
    sttNumber: "",
    weight: 0,
    length: 0,
    width: 0,
    height: 0,
    isRTC: false,
    photoProof: [] as string[]
  };

   photoProof: string[] = [];

  isUnpaid = false;
  isErrorNotification = false;

  get isDisableAddSttNumber() {
    return !this.form.sttNumber;
  }

  // Origin City
  get originCity() {
    return `${this.dataProfile.account_location.city_code} - ${this.dataProfile.account_location.city_name}`;
  }

  // Destination City
  fetchDestinationCity = debounce((search: string) => {
    if (search.length > 2 || !search) {
      LocationController.getCityList({
        search: search,
        status: "",
        page: 1,
        limit: 10,
      });
    }
  }, 250);
  get destinationCityList() {
    return LocationController.cityData.cityData.map((e) => ({
      id: e.id,
      name: `${e.code} - ${e.name}`,
      transit: e.originTransit
        ? `${e.destinationCodeTransit} - ${e.destinationTransit}`
        : "-",
      code: e.code,
    }));
  }
  get isLoadingDestinationCity() {
    return LocationController.isLoadingDistrict;
  }

  regionBaggingGrouping = new RegionBaggingGrouping();
  loadingRegion = false;

  get showRecommendationRegion() {
    return (
      this.form.destinationCity?.code &&
      !this.loadingRegion &&
      this.showNotesDestination &&
      this.regionBaggingGrouping.baggingRegionDestinationId &&
      this.regionBaggingGrouping.baggingRegionDestinationName &&
      this.form.destinationCity?.code !==
        this.regionBaggingGrouping.baggingRegionDestinationId &&
      this.dataProfile.account_location.city_code !==
        this.regionBaggingGrouping.baggingRegionDestinationId &&
      this.regionBaggingGrouping.baggingRegionOriginId !==
        this.regionBaggingGrouping.baggingRegionDestinationId
    );
  }

  async getRegionBaggingGrouping(code: string) {
    if (code) {
      try {
        this.loadingRegion = true;
        MainAppController.closeErrorMessage();
        this.regionBaggingGrouping = await BaggingController.getRegionBaggingGrouping(
          code
        );
        this.showNotesDestination = true;
      } catch (error) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(
            error,
            "Gagal Mendapatkan Region Bagging Grouping",
            () => this.getRegionBaggingGrouping(code)
          )
        );
        this.showNotesDestination = false;
      } finally {
        this.loadingRegion = false;
      }
    }
  }

  // convert value decimal
  isValueDecimal(value: number): number | string {
    return convertDecimal(value);
  }

  // format total kg
  convertTotalKg(value: number): number {
    return value;
  }

  formatWeight(n: number): string {
    return formatByCountry(n, { type: "weight", suffix: " Kg" });
  }

  formatWeightInput(value: string | number): string {
    if (typeof value === "number") {
      return formatByCountry(value, { type: "weight" });
    }
    return formatInputByCountry(this.normalizeWeightInput(value), { type: "weight" });
  }

  normalizeWeightInput(value: string): string {
    const normalized = value.replace(/[^\d.,-]/g, "");
    const decimalIndex = Math.max(
      normalized.lastIndexOf("."),
      normalized.lastIndexOf(",")
    );
    const fraction = normalized.slice(decimalIndex + 1);
    if (decimalIndex < 0 || !fraction || fraction.length > 2) {
      return normalized;
    }
    const decimal = resolveCountry() === "MY" ? "." : ",";
    return `${normalized.slice(0, decimalIndex)}${decimal}${fraction}`;
  }

  parseWeightInput(value: string | number): number {
    return parseByCountry(
      typeof value === "number" ? value : this.normalizeWeightInput(value)
    );
  }

  formatCod(amount: number): string {
    return formatByCountry(amount, { type: "money", prefix: "Rp" });
  }

  // panel pickup
  chevron = false;
  togglePanel(event: any) {
    const refs: any = this.$refs;
    refs.op?.toggle(event);
    this.chevron = !this.chevron;
  }

  // notification handler
  notification = false;
  detailSttNotification: any = null;
  notificationCommodityGrouping = false;
  detailNotificationCommodityGrouping: any = null;

  // table
  sourceSttFromLocalStorage: any = JSON.parse(
    localStorage.getItem("bagging") || "[]"
  );
  get dataSttToBeCreate() {
    storeDatatoLocalStorage("bagging", this.sourceSttFromLocalStorage);
    return this.sourceSttFromLocalStorage;
  }
  get columns() {
    return [
      {
        name: "No.",
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail, index: number) => {
          return `<div class="text-black-lp-300">${index + 1}</div>`;
        },
      },
      {
        name: `No. STT`,
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div data-testid="bagging-scan-create-column-stt-cell" class="text-black-lp-300"><span data-testid="bagging-scan-list-row-stt-no-${item.sttNo}">${item.sttNo}</span>${item.isWoodpacking ? `<br/><span class="woodpacking-chips woodpacking-chips--tariff" data-testid="bagging-scan-list-row-woodpacking-chip-${item.sttNo}">KAYU</span>` : ""}</div>`;
        },
      },
      {
        name: this.$t("No. Referensi"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 break-all">${
            isFormatLiloBag(item.sttNoRefExternal)
              ? "-"
              : item.sttNoRefExternal || "-"
          }</div>`;
        },
      },
      {
        name: this.$t("Chargeable weight"),
        styleHead: "w-56 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttChargeableWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
       },
      {
        name: this.$t("bagging.grossWeight"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttGrossWeight, { type: "weight", suffix: " kg" })}</div>`;
        },
      },
      {
        name: this.$t("bagging.volumeWeight"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttVolumeWeight, { type: "weight", suffix: " kg" })}</div>`;
        },
      },
      {
        name: this.$t("Koli"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${item.sttTotalPiece}</div>`;
        },
      },
      {
        name: this.$t("bagging.tableTitle.serviceType"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 flex">
                  <div class="rounded px-2 py-0 bg-gray-lp-400">
                    ${item.sttProductType}
                  </div>
                </div>`;
        },
      },
      {
        name: this.$t("Komoditas"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 break-all">${item.sttCommodityName}</div>`;
        },
      },
      {
        name: this.$t("bagging.tableTitle.destinationType"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 flex">
                  <div class="rounded px-2 py-0 bg-gray-lp-400">
                      ${item.sttDestinationCityId}
                  </div>
                </div>`;
        },
      },
      {
        name: "Dangerous Goods",
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${item.isDangerousGoods ? this.$t("bagging.yes") : this.$t("bagging.no")}</div>`;
        },
      },
       {
        name: this.$t("bagging.action"),
        key: "button_column",
        styleHead: "w-40 text-center",
        styleButton: (item: SttNumberDetail) => {
          return {
            outline: true,
            title: this.$t("bagging.hapus"),
            textColor: "red-lp-700",
            color: "red-lp-700",
            customClass: "text-center w-full font-semibold px-2.5 py-2",
            small: false,
            iconLeft: "trash-red",
            compact: true,
            clickFunction: () => {this.onDeleteSttItem(item)}
          };
        },
      }
    ];
  }

  // role account user
  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }

  get listSttPieces() {
    return this.dataSttToBeCreate.map((e: any) => {
      return e.sttNo;
    });
  }

  withPrint = false;

  onDelaySave = debounce(() => {
    this.onSave();
  }, 250);

  onShowLoadingSave() {
    this.handleConfirmationSave(false);
    MainAppController.showLoading();
    this.onSave();
  }

  async onSave() {
    const destination: any = this.form.destinationCity;
    const payload = new PayloadCreateBagging({
      destinationCityCode: destination.code,
      customGrossWeight: this.parseWeightInput(this.form.weight),
      customLength: this.form.length,
      customWidth: this.form.width,
      customHeight: this.form.height,
      productType: this.filterDominanProductAndCommodity(
        this.listSttProduct,
        this.listSttCommodityGroup
      ).product,
      commodityGroupCode: this.filterDominanProductAndCommodity(
        this.listSttProduct,
        this.listSttCommodityGroup
      ).commodity,
      isRtc: this.form.isRTC,
      bagStt: this.listSttPieces,
      totalBagChargeableWeight: this.bagChargeableWeight,
      totalSttDgCount: this.totalDangerousGoods,
      totalPieceSttDgCount: this.totalDangerousGoods,
      totalSttGrossWeight: this.totalGrossWeight,
      totalSttVolumeWeight: this.totalVolumeWeight,
      totalSttChargeableWeight: this.sttChargeableWeight,
      isUseNewCalculation: true,
      photoProof: this.form.photoProof,
      customVolumeWeight: Number(this.totalBagVolumeWeight)
    });
    const respCreateBagging = await BaggingController.onGenerate(payload);
    if (respCreateBagging.data) {
      if (
        respCreateBagging.data.totalSttFailed > 0 &&
        respCreateBagging.data.totalSttSuccess === 0
      ) {
        this.countFailed = respCreateBagging.data.totalSttFailed;
        this.setFailed(true);
        BaggingController.setSttFailedUpdate(respCreateBagging.data.sttFailed);
        dataLayer(
          "create_bagging_failed",
          { error_message: "bagging gagal dibuat" },
          []
        );
      } else if (
        respCreateBagging.data.totalSttFailed > 0 &&
        respCreateBagging.data.totalSttSuccess > 0
      ) {
        this.countFailed = respCreateBagging.data.totalSttFailed;
        this.countSuccess = respCreateBagging.data.totalSttSuccess;
        BaggingController.setSttFailedUpdate(respCreateBagging.data.sttFailed);
        this.isPartial = true;
      } else {
        this.setOpenSuccess(true);
        this.onReset();
        dataLayer(
          "create_bagging_success",
          {
            bagging_number: respCreateBagging.data.bagCode,
            total_stt: this.totalStt,
            total_koli: this.totalPieces,
          },
          []
        );
        if (this.withPrint) {
          MainAppController.showLoading();
          const printLabel = await BaggingController.getDetailBagging(
            respCreateBagging.data.bagId
          );
          if (printLabel) {
            const detailData = BaggingController.baggingDetail;
            const labelData = new BaggingData({
              bagId: BaggingController.responseCreate.data.bagId,
              bagCode: detailData.bagNumber,
              bagPartnerId: 0,
              bagPartnerCode: "",
              bagPartnerName: detailData.partnerName,
              bagOriginCityCode: detailData.originCity.slice(0, 3),
              bagOriginCityName: detailData.originCity.substring(
                6,
                detailData.originCity.length
              ),
              bagOriginTransitCityCode: "",
              bagOriginTransitCityName: "",
              bagDestinationCityCode: detailData.destinationCity.slice(0, 3),
              bagDestinationCityName: detailData.destinationCity.substring(
                6,
                detailData.destinationCity.length
              ),
              bagTotalStt: detailData.totalStt,
              bagTotalGrossWeight: detailData.totalGrossWeight,
              bagTotalVolumeWeight: detailData.totalVolumeWeight,
              bagTotalChargeableWeight: detailData.totalBagChargeableWeight,
              bagTotalPiece: detailData.totalPiece,
              bagCreatedAt: new Date(detailData.baggingDate).toISOString(),
              bagCreatedBy: 0,
              bagCreatedName: "",
              bagCustomGrossWeight: detailData.totalBagGrossWeight,
              bagCustomVolumeWeight: detailData.totalBagVolumeWeight,
              userType: "",
            });
            this.refs.print.printLabel(labelData);
            dataLayer(
              "create_bagging_success_label",
              {
                bagging_number: respCreateBagging.data.bagCode,
                total_stt: this.totalStt,
                total_koli: this.totalPieces,
              },
              []
            );
          }
          MainAppController.closeLoading();
        }
      }
      this.sourceSttFromLocalStorage = [];
    }
    this.photoProof = [];
    this.form.photoProof = [];
  }

  createAndPrint(withPrint: boolean) {
    const refs: any = this.$refs;
    refs.op?.hide();
    this.withPrint = withPrint;
    this.handleConfirmationSave(true);
  }

  // handle route leave and modal
  // navigation
  get openSuccess(): boolean {
    return BaggingController.isOpenSuccess;
  }
  setOpenSuccess(value: boolean) {
    BaggingController.setOpenSuccess(value);
  }

  // failed for create
  get isFailed(): boolean {
    return BaggingController.isFailed;
  }
  setFailed(value: boolean) {
    BaggingController.setFailed(value);
  }

  openConfirmationLeave = false;
  openConfirmationSave = false;
  answer = false;
  newPath = "";
  handleConfirmationLeave(value: boolean) {
    this.openConfirmationLeave = value;
  }
  handleConfirmationSave(value: boolean) {
    this.openConfirmationSave = value;
  }
  goBack() {
    this.$router.push("/bagging");
  }
  onOpenClosePage(to: any) {
    this.handleConfirmationLeave(true);
    this.newPath = to.path;
  }
  handlerClose() {
    removeDataLocalStorage("bagging");
    removeDataLocalStorage("baggingGrossWeight");
    this.onReset();
    this.handleConfirmationLeave(false);
    this.answer = true;
    this.$router.push(this.newPath);
  }
  handlerCancelClose() {
    this.answer = false;
    this.handleConfirmationLeave(false);
  }
  onCloseSuccess() {
    this.goBack();
  }

  // error message
  onResetIsAlreadyExist() {
    this.form.sttNumber = "";
    this.errorSttNumber = "";
    this.isDuplicateScan = false;
    this.isErrorTyping = false;
    // re focus
    const inputStt: any = this.$refs.inputStt;
    inputStt.focus();
  }

  numberOnly(value: any) {
    return this.formatWeightInput(value);
  }

  onBlurGrossWeight() {
    const convertWeight = this.parseWeightInput(this.form.weight);
    if (convertWeight <= 0.09) {
      this.form.weight = 0.1;
    }
  }

  onChangeWeight(value: any) {
    this.isChangeWeight = true;
     this.form.length = 90;
     this.form.width = 60;
    if (this.isFirstLanding) {
     this.isFirstLanding = false;
    }

    let newValue = this.parseWeightInput(value);
    if (isNaN(newValue)) {
      newValue = 0;
    }

    if (value === "0") {
      newValue = 0;
    }

    // 🔹 Hitung height (manual trigger on blur)
    if (!this.isFirstLanding && this.form.length && this.form.width) {
       const result = 
        (Number(this.isValueDecimal(Number(this.totalBagVolumeWeight))) * this.dimensionDivider) /
        (this.form.length * this.form.width);
       
      const decimalPartResult = result - Math.floor(result);

      let finalHeight;
      if (decimalPartResult > 0) {
        finalHeight = Math.floor(result);
        if (finalHeight === 0) finalHeight = 1;
      } else {
        finalHeight = result;
      }

      this.form.height = finalHeight;
    }

  }


  get alertPopup() {
    const onDownload = () =>
      this.downloadCsvFailedStt({
        fileName: "bagging_stt_failed.csv",
        listStt: this.sttFailedUpdate,
      });
    // if success
    if (this.openSuccess)
      return {
        onClick: () => this.onCloseSuccess(),
        title: this.form.isRTC
          ? this.$t("bagging.createRtcSuccessTitle")
          : this.$t("bagging.createSuccessTitle"),
        message: this.form.isRTC
          ? this.$t("bagging.createRtcSuccessMessage")
          : this.$t("bagging.createSuccessMessage"),
        image: "image-modal-success",
      };
    // if error typing not found
    if (this.isErrorTyping) {
      dataLayer(
        "input_STT/bagging_failed",
        {
          error_message: this.isScan
            ? this.$t("bagging.scanSttFailedTitle")
            : this.$t("bagging.addSttFailedTitle"),
        },
        []
      );
      return {
        onClick: () => this.onResetIsAlreadyExist(),
        title: this.isDuplicateScan ? this.$t("STT Sudah Di Scan") : this.isScan
          ? this.$t("bagging.scanSttFailedTitle")
          : this.$t("bagging.addSttFailedTitle"),
        message: this.isDuplicateScan ? "" : this.$t(this.errorSttNumber),
        image: this.isDuplicateScan ? "image-modal-success" : "image-modal-failed",
      };
    }
    // if error typing not found
    if (this.isPartial)
      return {
        onClick: () => this.onCloseSuccess(),
        onDownload: onDownload,
        title: this.$t("bagging.createSuccessTitle"),
        message: this.$t("bagging.createPartialMessage"),
        image: "image-modal-warning",
      };
    // default is failed
    return {
      onClick: () => this.setFailed(false),
      onDownload: onDownload,
      title: this.$t("bagging.createFailedTitle"),
      message: this.$t("bagging.createFailedMessage"),
      image: "image-modal-failed",
    };
  }

  get isErrorGrossWeight() {
    if (this.isFirstLanding) {
      return false;
    }
    return !this.parseWeightInput(this.form.weight);
  }
  get isErrorDimension() {
    if (this.isFirstLanding) {
      return false;
    }
    return (
      !this.totalBagVolumeWeight ||
      !this.form.width ||
      !this.form.length ||
      !this.form.height
    );
  }

  get isDisableProcess() {
    return (
      this.parseWeightInput(this.form.weight) === 0 ||
      this.totalBagVolumeWeight === 0 ||
      this.form.width === 0 ||
      this.form.length === 0 ||
      this.form.height === 0 ||
      (this.bagWeightOverSttWeight && !this.isUploadPhotoAdjustWeightValid && this.isValidationPhotoProofHasPermission) ||
      this.isMaxWeightDispute
    );
  }

  get isUploadPhotoAdjustWeightValid() {
    return  this.form.photoProof.filter((photo) => photo).length > 0
  }

  get sttFailedUpdate() {
    return BaggingController.sttFailedUpdate;
  }

  // migrate from elexys
  get isMigrateFromElexys() {
    return isMigrateFromElexys();
  }
  get sttNumberGenesisTitle() {
    return `No. STT ${this.isMigrateFromElexys ? "Genesis" : ""}`;
  }

  get listSttProduct() {
    return this.dataSttToBeCreate.map((e: any) => {
      return e.sttProductType;
    });
  }

  get listSttCommodityGroup() {
    return this.dataSttToBeCreate.map((e: any) => {
      return e.sttCommodityGroupCode;
    });
  }

  filterDominanProductAndCommodity(products: [], commodities: []) {
    const product = this.countPopularityItems(products);
    const commodity = this.countPopularityItems(commodities);
    return {
      product: this.findMaxItems(product),
      commodity: this.findMaxItems(commodity),
    };
  }

  countPopularityItems(arr: any) {
    const data = arr.reduce((accumulator: any, item: any) => {
      return (accumulator[item] = (accumulator[item] || 0) + 1), accumulator;
    }, {});
    return Object.entries(data).map((item: any[]) => ({
      name: item[0],
      total: item[1],
    }));
  }

  findMaxItems(totalDataByItem: any) {
    const findMax = totalDataByItem.reduce((prev: any, current: any) =>
      prev.total > current.total ? prev : current
    );
    const maxIndexLocation = totalDataByItem.reduce(
      (accumulator: any, currentValue: any, currentIndex: any) =>
        currentValue.total === findMax.total
          ? accumulator.concat(currentIndex)
          : accumulator,
      []
    );
    const result: any = [];
    maxIndexLocation.forEach((key: any) => {
      result.push(totalDataByItem[key].name);
    });
    return result.toString();
  }

  showNotesDestination = false;
  isDiffDestination = false;

  onConfirmDangerousGoods() {
    this.alertDangerousGoods = false;
    this.notification = true;

    // re focus
    const inputStt: any = this.refs.inputStt;
    inputStt.focus();
  }

  formatNoDecimal(value: string) {
    const valueNumberOnly = this.numberOnly(value);
    return formatInputNoDecimal(valueNumberOnly);
  }

  onDeleteSttItem(item: SttNumberDetail) {
    this.sttNumberToDelete = item.sttNo;
    this.onDeleteSttNumber()
  }

  get dimensionDivider() {
    return FlagsPermissionBagging.config_dimension_divider.getValue();
  }
}
export default CreateFormBaggingManifest;
